import React from "react";
import { Checkbox } from "../Checkbox";
import {
  CaretButton,
  CaretIcon,
  IconWrap,
  Label,
  LeftCluster,
  Row,
} from "./SectionToggleRow.styles";
import type { SectionToggleRowProps } from "./SectionToggleRow.types";

/**
 * One Sections-panel row, at any depth. Presentation only — every visual
 * difference between a parent widget row and an indented sub-part row is
 * resolved by `$depth` inside SectionToggleRow.styles.ts, so this file never
 * branches on widget type or depth. Figma 6515:241220 (Charts, expanded) /
 * 6541:75295 (KPI cards).
 */
export const SectionToggleRow: React.FC<SectionToggleRowProps> = ({
  icon: Icon,
  label,
  depth,
  expandable = false,
  expanded = false,
  onToggleExpand,
  checked,
  onCheckedChange,
  highlighted = false,
  ariaLabel,
  className,
}) => (
  <Row $depth={depth} className={className}>
    <LeftCluster>
      {Icon && (
        <IconWrap aria-hidden>
          <Icon size={16} />
        </IconWrap>
      )}
      <Label $depth={depth} $highlighted={highlighted}>
        {label}
      </Label>
      {expandable && (
        <CaretButton
          type="button"
          aria-label={expanded ? `Collapse ${label}` : `Expand ${label}`}
          aria-expanded={expanded}
          onClick={onToggleExpand}
        >
          <CaretIcon
            $expanded={expanded}
            viewBox="0 0 8 4"
            fill="none"
            aria-hidden
          >
            <path d="M0.5 0.5L4 3.5L7.5 0.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
          </CaretIcon>
        </CaretButton>
      )}
    </LeftCluster>
    <Checkbox
      checked={checked}
      onChange={onCheckedChange}
      ariaLabel={ariaLabel ?? label}
    />
  </Row>
);

export default SectionToggleRow;
